import './App.css';
import Navbar from './Navbar/Navbar.jsx';
import Hero from './Hero/Hero.jsx';
import About from './About/About.jsx';
import Contact from './Contact/Contact.jsx';
import Footer from './Footer/Footer.jsx';
import DynamicTile from './DynamicTile/DynamicTile.jsx';
import Expirence from './Expirence/Expirence.jsx';
import Projects from './Projects/Projects.jsx';
import Certs from './Certs/Certs.jsx';

import Snowfall from 'react-snowfall';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

  return (
    <div className="app-wrapper">
      <div className="app-background-elements">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="glow-orb orb-1"></div>
        <div className="glow-orb orb-2"></div>
      </div>
      {/* Śnieg */}
      {/* <Snowfall color="#82C3D9" style={{position: "fixed",top: 0,left: 0,width: "100vw",height: "100vh",zIndex: 0,pointerEvents: "none"}}/> */}
      <Navbar />
      <Hero />
      <About />
      <Expirence />
      <Projects />
      <Certs />
      <Contact />
      <Footer />
      <DynamicTile />

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
}

export default App;
